import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../css/DataDetail.css";
import axiosInstance from '../config/axiosConfig';

function App() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("Participación");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(`/Data/${id}`);
        setData(response.data);
        setError(null);
      } catch (err) {
        console.error('Error al obtener datos:', err);
        setError('No se pudo cargar los datos');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const tabContent = {
    "Participación": {
      label1: "Alcance de Participación", value1: data?.alcance_participacion,
      label2: "Nivel de Participación", value2: data?.nivel_participacion,
      label3: "1. Participación de la OG en la COMUSAN", value3: data?.participacion_og_comusan,
      label4: "2. Participación de ONG en la COMUSAN", value4: data?.participacion_ong_comusan,
      label5: "3. Participación de OSC en la COMUSAN", value5: data?.participacion_osc_comusan,
      label6: "4. Participación Sector Privado en la COMUSAN", value6: data?.participacion_sector_privada_comusan,
      label7: "5. COCOSANes establecidas", value7: data?.cocosanes_establecidas,
      label8: "6. Proceso de toma de decisiones participativas en temas SAN a nivel municipal", value8: data?.proceso_toma_decisiones_participativas,
    },
    "Equidad": {
      label1: "Alcande de Equidad", value1: data?.alcance_equidad,
      label2: "Nivel de Equidad", value2: data?.nivel_equidad,
      label3: "7. Grupos de mujeres participando en procesos impulsados por la COMUSAN", value3: data?.mujeres_participando_procesos_impulsados_COMUSAN,
      label4: "8. Grupos de jóvenes participando en procesos impulsados por la COMUSAN", value4: data?.jovenes_participando_procesos_impulsados_COMUSAN,
      label5: "9. Representantes comunitarios del área rural participando en procesos impulsados por la COMUSAN", value5: data?.representantes_comunitarios_area_rural_en_procesos_impulsados_comusan,
      label6: "10. Acciones de apoyo al adulto mayor incluidas en el Plan de acción de la COMUSAN", value6: data?.acciones_apoyo_adulto_mayor_en_plan_accion_comusan,
      label7: "11. Consideraciones relacionadas con la interculturalidad incluidas en las acciones de COMUSAN", value7: data?.consideraciones_relacionadas_interculturalidad_incluidas_acciones_comusan,
    },
    "Transparencia": {
      label1: "Alcance de Transparencia", value1: data?.alcance_transparencia,
      label2: "Nivel de Transparencia", value2: data?.nivel_transparencia,
      label3: "12. Rendición de cuentas (informes)", value3: data?.redencion_cuentas,
      label4: "13. Informes de uso y asignación de recursos municipales en acciones y obras relacionadas con la SAN", value4: data?.informes_uso_asignacion_recursos_mmunicipales_acciones_obras_relacionadas_san,
      label5: "14. Sistema de monitoreo de las acciones de SAN establecido a nivel municipal", value5: data?.sistema_monitoreo_acciones_san_establecido_nivel_municipal,
    },
    "Eficiencia": {
      label1: "Alcance de Eficiencia", value1: data?.alcance_eficiencia,
      label2: "Nivel de Eficiencia", value2: data?.nivel_eficiencia,
      label3: "15. Porcentaje de avance de POASAN Municipal", value3: data?.porcentaje_avance_poasan_municipal,
      label4: "16. Programas y proyectos de SAN con presupuesto municipal asignado", value4: data?.programas_proyectos_san_presupuesto_municipal_asignado,
      label5: "17. Nivel de capacidad de respuesta de la COMUSAN ante situaciones de INSAN", value5: data?.nivel_capacidad_respuesta_comusan_ante_situacion_insan,
      label6: "18. Inversiones priorizadas en SAN de acuerdo con un diagnóstico municipal de SAN", value6: data?.inversiones_priorizadas_san_acuerdo_diagnostico_municipal_san,
    },
    "Capacidad de Respuesta": {
      label1: "Alcance de Capacidad de Respuesta ", value1: data?.alcance_capacidad_respuesta,
      label2: "Nivel de Capacidad de Respuesta", value2: data?.nivel_capacidad_respuesta,
      label3: "19. Diagnóstico municipal SAN", value3: data?.diagnostico_municiapal_sam,
      label4: "20. Sistema de alerta temprana establecido a nivel municipal", value4: data?.sistema_alerta_temprana_establecida_nivel_municipal,
      label5: "21. Sala Situacional Municipal de SAN establecida", value5: data?.sala_situacional_minucipal_san_establecida,
      label6: "22. Plan de Comunicación de SAN a nivel municipal", value6: data?.plan_comunicacion_san_nivel_municipal,
      label7: "23. Acciones de SAN implementadas en el municipio", value7: data?.acciones_san_implementadas_municipio,
      label8: "24. Oficinas Municipales de SAN -OMSAN- establecidas", value8: data?.oficinas_municipales_san_omsan_establecidas,
      label9: "25. POASAN municipal", value9: data?.poasan_municiapl,
      label10: "26. Planes de capacitación y actualización de conocimientos de SAN para los técnicos que participan en la COMUSAN", value10: data?.planes_capacitacion_actualizacion_conocimiento_san_tecnicos_participan_comusan,
    },
    "Coordinación": {
      label1: "Índice de Coordinación", value1: data?.alcance_coordinacion,
      label2: "Nivel de Coordinación", value2: data?.nivel_coordinacion,
      label3: "27. Acuerdos de coordinación intersectorial establecido", value3: data?.acuerdos_coordinacion_intersectorial_establecidos,
      label4: "28. Mesa técnica interinstitucional del MSPAS para el análisis de la morbi-mortalidad asociada a desnutrición aguda a nivel municipal", value4: data?.mesa_tecnica_interinstitucional_mspas_analisis_morbimortalidad_asociada_desnutricion_aguda_nivel_municipal,
      label5: "29. Personal de SESAN asignado al municipio ", value5: data?.personal_sesan_asignado_municipio,
    },
    "Marco Regulatorio": {
      label1: "Alcance de Marco Regulatorio", value1: data?.alcance_marco_regulatorio,
      label2: "Nivel de Marco Regulatorio", value2: data?.nivel_marco_regulatorio,
      label3: "30. Respaldo del gobierno municipal hacia la COMUSAN", value3: data?.respaldo_gobierno_municipal_hacia_comusan,
      label4: "31. Cumplimiento de la COMUSAN con el marco normativo establecido por la SESAN", value4: data?.cumplimiento_comusan_marco_normativo_establecido_sesan,
    },
  };

  if (loading) return <p>Cargando datos...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;
  if (!data) return <p>No hay datos disponibles</p>;

  return (
    <div className="content-wrapper">
      <h1 className="title">{data.anio}{data.cuatrimestre} {data.municipio}, {data.departamento}</h1>

      <div className="info-block">
        <div className="info-row">
          <div className="info-label">Departamento</div>
          <div className="info-value">{data.departamento}</div>
        </div>
        <div className="info-row">
          <div className="info-label">Municipio</div>
          <div className="info-value">{data.municipio}</div>
        </div>
        <div className="info-row">
          <div className="info-label">Año</div>
          <div className="info-value">{data.anio}</div>
        </div>
        <div className="info-row">
          <div className="info-label">Cuatrimestre</div>
          <div className="info-value">{data.cuatrimestre}</div>
        </div>
        <div className="info-row">
          <div className="info-label">Índice de Gobernanza</div>
          <div className="info-value">{data.indice_gobernanza}</div>
        </div>
        <div className="info-row">
          <div className="info-label">Nivel de Gobernanza</div>
          <div className="info-value">{data.nivel_gobernanza}</div>
        </div>
        <div className="info-row">
          <div className="info-label">Código de Técnico</div>
          <div className="info-value">{data.codigo_tecnico}</div>
        </div>
        <div className="info-row">
          <div className="info-label">Técnico</div>
          <div className="info-value">{data.tecnico}</div>
        </div>
        <div className="info-row">
          <div className="info-label">Fecha de Ingreso</div>
          <div className="info-value">{data.fecha}</div>
        </div>
        <div className="info-row">
          <div className="info-label">Aprobado</div>
          <div className="info-value">{data.aprobado === 0 ? "Sí" : "No"}</div>
        </div>
      </div>

      <div className="tables-container">
        <div className="tabs">
          {Object.keys(tabContent).map((tab) => (
            <button
              key={tab}
              className={`tab-button ${activeTab === tab ? "active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="info-block">
          {Object.keys(tabContent[activeTab])
            .filter(key => key.startsWith("label"))
            .map((labelKey) => {
              const number = labelKey.replace("label", "");
              const valueKey = `value${number}`;
              return (
                <div className="info-row" key={labelKey}>
                  <div className="info-label">{tabContent[activeTab][labelKey]}</div>
                  <div className="info-value">{tabContent[activeTab][valueKey]}</div>
                </div>
              );
            })}
        </div>
      </div>

      <button className="back-button" onClick={() => navigate("/datos")}>Volver</button>
    </div>
  );
} (
    <p>Cargando datos...</p>
  );

export default App;